import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-1-small', 'Number1Small', [["path",{"d":"M11 8h1v8"}]]);